export class OrganzationProfile {
	id: number | null = null
	coverUrl: string = ''
	logoUrl: string = ''
	thumbLogoUrl: string = ''
	businessName: string = ''
	status: number | null = null
	type: {
		id: number
		name: {
			en: string
			ar: string
		}
	} | null = null
	isActive!: true
	country: {
		id: number
		name: {
			en: string
			ar: string
		}
		flagUrl: string
	} | null = null
	fullName: string = ''
	mobileNumber: string = ''
	email: string = ''
	branches: {
		id: number
		name: string
		isActive: boolean
		isInformationCompleted: boolean
		isMain: boolean
		address: string
	}[] = []
}
